import React, { useState } from 'react';
import {
    SelectFormality,
    useDomaine,
    useDossierRoutingContext,
    useOrigine,
    useSelectedDossierContext,
} from '@europrocurement/l2d-modules';
import { Box, Typography } from '@mui/material';
import { FaOptionIcon, informationIcon } from '@europrocurement/l2d-icons';
import { CatalogApiObject } from '@europrocurement/l2d-domain';
import { useNavigate } from 'react-router';
import { enqueueSnackbar } from 'notistack';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAddFormality } from '../../hooks';

const DossierAddFormality: React.FunctionComponent = function () {
    const { dossier, refreshDossier } = useSelectedDossierContext();
    const { getDossierRoute } = useDossierRoutingContext();
    const navigate = useNavigate();
    const { addFormality } = useAddFormality();
    const domaineId = useDomaine();
    const origineId = useOrigine();
    const [processing, setProcessing] = useState<boolean>(false);

    const handleAddFormality = async (values: {
        ids: Array<number>;
        catalogs: CatalogApiObject[];
    }) => {
        setProcessing(true);
        try {
            await addFormality(values.catalogs);

            setTimeout(() => {
                refreshDossier();
                navigate(getDossierRoute(dossier.id as number));
            }, 1000);
        } catch (err) {
            enqueueSnackbar("Une erreur est survenue lors de l'ajout de votre formalité", {
                variant: 'error',
            });
            console.error(err);
            setProcessing(false);
        }
    };

    const handleReturnToDossier = () => {
        navigate(getDossierRoute(dossier.id as number));
    };

    return (
        <>
            <Box
                onClick={handleReturnToDossier}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '16px',
                    color: 'text.gris50',
                    '&:hover': { cursor: 'pointer' },
                }}
            >
                <FontAwesomeIcon icon={faArrowLeft} />
                <Typography>Revenir au dossier</Typography>
            </Box>
            <Typography
                component="h2"
                variant="l2dh4"
                sx={{
                    lineHeight: 1.4,
                }}
            >
                Quelle(s) formalité(s) souhaitez-vous réaliser ?
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    fontSize: '18px',
                    marginTop: '15px',
                    marginBottom: '15px',
                }}
            >
                <Typography
                    variant="l2dlabel"
                    color="text.secondary"
                >
                    <FaOptionIcon {...informationIcon.props} />
                </Typography>
                <Box
                    fontSize="14px"
                    marginLeft="8px"
                >
                    <Typography
                        variant="l2dlabel"
                        color="text.secondary"
                    >
                        Vous pouvez sélectionner plusieurs formalités à créer pour une même société.
                    </Typography>
                </Box>
            </Box>
            <Box>
                <SelectFormality
                    origine={origineId}
                    domaine={domaineId}
                    prescripteurId={dossier?.prescripteurId as number}
                    onChange={handleAddFormality}
                    disableSubmit={processing}
                />
            </Box>
        </>
    );
};

export default DossierAddFormality;
